@if (showCampaignBanner && slides().length > 0) {
  <p-carousel
    [value]="slides()"
    [circular]="true"
    [autoplayInterval]="3600"
    [showIndicators]="false"
    [page]="0"
  >
    <ng-template let-slide pTemplate="item">
      @if (slide.href) {
        <a [href]="slide.href" target="_blank" aria-label="slide">
          <img class="rounded-lg" [src]="slide.src" [alt]="slide.alt" />
        </a>
      } @else {
        <img class="rounded-lg" [src]="slide.src" [alt]="slide.alt" />
      }
    </ng-template>
  </p-carousel>
}
